module.exports = __webpack_public_path__ + "static/media/B1.b12ed49a.webp";